import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/man.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex h-screen mx-auto"
}
const _hoisted_2 = { class: "self-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-3xl font-medium" }, "Hi there!", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { class: "mb-6 mt-4 border-gray-800" }, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "h-screen grid sm:grid-cols-3 lg:grid-cols-4"
}
const _hoisted_6 = { class: "pt-4 md:pt-10" }
const _hoisted_7 = { class: "grid grid-cols-3 items-center pb-8" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-32 justify-self-end py-3"
}, null, -1)
const _hoisted_9 = { class: "justify-self-start p-3 col-span-2" }
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Some important detail", -1)
const _hoisted_12 = { class: "col-span-2 lg:col-span-3 p-4 md:p-10 bg-secondary" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 text-4xl" }, "your forms", -1)
const _hoisted_15 = { class: "flex flex-col py-6" }
const _hoisted_16 = { class: "font-bold p-2" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700 text-4xl" }, "TODO Netlify Identity Stuff Here", -1)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HollowButtonVue = _resolveComponent("HollowButtonVue")!
  const _component_VerticalTabsVue = _resolveComponent("VerticalTabsVue")!
  const _component_FormCardVue = _resolveComponent("FormCardVue")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.auth0?.isLoading.value || !_ctx.auth0?.isAuthenticated.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", {
            class: "w-24 mx-auto",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.auth0?.login()))
          }, [
            _createVNode(_component_HollowButtonVue, { text: 'Log In' })
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.auth0?.user.value?.name), 1),
              _hoisted_11,
              _createElementVNode("div", {
                class: "w-32",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.auth0?.logout()))
              }, [
                _createVNode(_component_HollowButtonVue, {
                  text: 'sign out',
                  class: "mt-2"
                })
              ])
            ])
          ]),
          _createVNode(_component_VerticalTabsVue, {
            "data-tree": _ctx.toc,
            "curr-section": _ctx.currSection,
            class: "px-10",
            onGotoSection: _cache[2] || (_cache[2] = ($event: any) => (_ctx.currSection = $event))
          }, null, 8, ["data-tree", "curr-section"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_ctx.currSection[0] === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result?.users[0].branches, (form_meta, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "flex flex-row pb-3"
                    }, [
                      _createElementVNode("p", _hoisted_16, _toDisplayString(index), 1),
                      _createVNode(_component_FormCardVue, { "form-meta": form_meta }, null, 8, ["form-meta"])
                    ]))
                  }), 128))
                ]),
                _createVNode(_component_router_link, { to: "/blankform/editor" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_HollowButtonVue, {
                      text: 'make a new form',
                      icon: 'plus',
                      class: "w-48 mx-auto"
                    })
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
        ])
      ]))
}